import React from 'react';
import Lottie from 'react-lottie';
import './Location_animation.css';
import * as animationData from './Location_animation.json';

function Location_animation(props) {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='success_div'>
                <div className='Location_Animation_icon'>
                    <Lottie className="me-auto"
                        options={defaultOptions}       
                    />
                </div>
                <p className='success_text'>{props?.successText}</p>
            </div>

        </section>
    );
}
export default Location_animation;